import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnifiedComponent } from './unified.component';
import { IntegrationComponent } from './integration/integration.component';
import { IntegrationCallbackComponent } from './integration-callback/integration-callback.component';

const routes: Routes = [
  {
    path: 'ntegration',
    component: UnifiedComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'ats'
      },
      {
        path: 'callback',
        component: IntegrationCallbackComponent
      },
      {
        path: ':category',
        component: IntegrationComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UnifiedRoutingModule { }
